/**
 * A Manage Assignments row can't be re-assigned or have its status changed when the
 * assignment is already completed / has a visit, or when the retailer itself is out of
 * play: closed, residential, or consumed by the Store Merger (`mergeStatus` is
 * "duplicate" / "historic").
 *
 * Keep the hover copy in `ui-kit/Checkbox` in sync with the reasons listed here.
 */
export const isAssignmentRowLocked = (row = {}) =>
  row.status === 1 ||
  Boolean(row.closedDate) ||
  Boolean(row.residential) ||
  Boolean(row.visitId) ||
  Boolean(row.mergeStatus);
